import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    overlay:
      'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-[10000] bg-black/50',
    contentContainer:
      'dialog data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed z-[10000] flex max-h-[calc(100vh_-_64px)] flex-col p-8',
    content:
      'relative w-[440px] flex-1 overflow-y-auto bg-white p-4 shadow-[0px_4px_11px_0px_rgba(29,31,34,0.1)] sm:p-10',
    closeButton:
      'text-icon-main dialog-data-[state=closed]:cursor-default absolute top-5 right-5 z-1 hidden size-10 p-2 sm:flex'
  },
  variants: {
    vertical: {
      bottom: {
        contentContainer: 'bottom-0'
      },
      center: {
        contentContainer: 'top-1/2 -translate-y-1/2'
      },
      top: {
        contentContainer: 'top-0'
      }
    },
    horizontal: {
      left: {
        contentContainer: 'left-0'
      },
      center: {
        contentContainer: 'left-1/2 -translate-x-1/2'
      },
      right: {
        contentContainer: 'right-0'
      }
    },
    fullScreen: {
      true: {
        contentContainer: 'inset-0 m-0 max-h-full translate-0 p-0',
        content: 'size-full',
        closeButton: 'top-2 right-2 flex'
      }
    }
  }
});
